import { updateFirstLoginPassword } from "../../Redux/Auth/AuthActions";
import { AppDispatch, RootState } from "../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import styles from "./PasswordModal.module.scss";
import Loading from "../Common/Loading/Loading";
import { FaRegEyeSlash } from "react-icons/fa6";
import validator from "../../Util/validator";
import { FaRegEye } from "react-icons/fa6";
import { useNavigate } from "react-router";
import Modal from "../Common/Modal/Modal";
import React, { useState } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  email: string;
}

function PasswordModal(props: Props) {
  const { isOpen, setIsOpen, email } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { updateFirstLoginPasswordLoading } = useSelector(
    (state: RootState) => state.auth,
  );
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState<{
    password: string;
    confirmPassword: string;
  }>({
    password: "",
    confirmPassword: "",
  });

  const updatePasswordHandler = () => {
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "password",
        type: "password",
        value: password,
      },
      {
        key: "confirmPassword",
        type: "confirmPassword",
        value: confirmPassword,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });
    if (isValid) {
      if (!updateFirstLoginPasswordLoading) {
        const successHandler = () => {
          setIsOpen(false);
          setPassword("");
          setConfirmPassword("");
        };
        dispatch(
          updateFirstLoginPassword(
            { email, password },
            successHandler,
            navigate,
          ),
        );
      }
    }
  };

  return (
    <React.Fragment>
      {updateFirstLoginPasswordLoading && <Loading />}
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={false}>
        <div className={styles.mainContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Update Password</h1>
          </div>

          <div className={styles.mainBodyContainer}>
            <div className={styles.description}>
              Please update your password to continue
            </div>
            <div className={styles.passwordInputContainer}>
              <p className={styles.label}>Password</p>
              <input
                type={showPassword ? "text" : "password"}
                className={styles.input}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                className={styles.showPasswordButton}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <FaRegEyeSlash className={styles.icon} />
                ) : (
                  <FaRegEye className={styles.icon} />
                )}
              </button>
            </div>
            <div className={styles.passwordInputContainer}>
              <p className={styles.label}>Confirm Password</p>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className={styles.input}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                className={styles.showPasswordButton}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <FaRegEyeSlash className={styles.icon} />
                ) : (
                  <FaRegEye className={styles.icon} />
                )}
              </button>
            </div>
            <div className={styles.buttonContainer}>
              <button
                className={styles.cancelButton}
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
              <button
                className={styles.updateButton}
                onClick={updatePasswordHandler}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default PasswordModal;
